import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { ApiKey, ApiKeysCreateRequest } from './types';

export const getApiKeys = (accountId: string) => {
  return doGet<ApiKey[]>(
    generateNextPath(ENDPOINTS.API_KEYS, { accountId }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const postApiKey = (accountId: string, body: ApiKeysCreateRequest) => {
  return doPost<ApiKey>(
    generateNextPath(ENDPOINTS.API_KEYS, { accountId }),
    LOGGER_TYPE.JUPITER,
    body,
    { version: 'v2' },
  );
};

export const deleteApiKey = (accountId: string, key: string) => {
  return doDelete<void>(
    generateNextPath(ENDPOINTS.API_KEYS, { accountId }),
    LOGGER_TYPE.JUPITER,
    { key },
    { version: 'v2' },
  );
};
